import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import React, {useState} from 'react';

import {TraceObjSchemaForBaseObjectClass} from '../wfReactInterface/objectClassQuery';
import {PanelSwitchComparisonView} from './PanelSwitchComparisonView';

type DropdownSwitchComparisonViewProps = {
  views: Array<TraceObjSchemaForBaseObjectClass<'ComparisonView'>>;
  currentViewId: string | null;
  currentViewerId: string | null;
  onLoadView: (
    view: TraceObjSchemaForBaseObjectClass<'ComparisonView'>
  ) => void;
};

export const DropdownSwitchComparisonView = ({
  views,
  currentViewId,
  currentViewerId,
  onLoadView,
}: DropdownSwitchComparisonViewProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLoadView = (
    view: TraceObjSchemaForBaseObjectClass<'ComparisonView'>
  ) => {
    setIsOpen(false);
    onLoadView(view);
  };

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <Button active={isOpen} variant="secondary" icon="menu" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="start">
          <PanelSwitchComparisonView
            views={views}
            currentViewId={currentViewId}
            currentViewerId={currentViewerId}
            onLoadView={handleLoadView}
          />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
